<template>
  <RevContainer>
    <RevCardCarousel
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
      size="extra-small"
      :title="i18n(translations.sectionTitle)"
    >
      <button
        v-for="category in categories"
        :key="category.name"
        class="flex flex-col items-start gap-8"
        type="button"
        @click="handleCategoryClick(category.name)"
      >
        <RevIllustration
          :alt="category.label"
          class="rounded-lg"
          :height="144"
          :src="category.image"
          :width="256"
        />
        <span class="heading-3">
          {{ category.label }}
        </span>
      </button>
    </RevCardCarousel>
  </RevContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './BuybackCategories.translations'

const i18n = useI18n()

const emit = defineEmits<{
  'category-click': [categoryName: string]
}>()

const categories = computed(() => [
  {
    name: 'iphone',
    label: i18n(translations.categoryIphone),
    image: '/img/buyback/pp/category-iphone.png',
  },
  {
    name: 'smartphone',
    label: i18n(translations.categorySmartphone),
    image: '/img/buyback/pp/category-smartphone.png',
  },
  {
    name: 'tablet',
    label: i18n(translations.categoryTablet),
    image: '/img/buyback/pp/category-tablet.png',
  },
  {
    name: 'macbook',
    label: i18n(translations.categoryMacbook),
    image: '/img/buyback/pp/category-macbook.png',
  },
  {
    name: 'gaming_console',
    label: i18n(translations.categoryGamingConsole),
    image: '/img/buyback/pp/category-gaming.png',
  },
  {
    name: 'audio',
    label: i18n(translations.categoryAudio),
    image: '/img/buyback/pp/category-audio.png',
  },
])

function handleCategoryClick(categoryName: string) {
  emit('category-click', categoryName)
}
</script>
